<template>
  <div></div>
</template>

<script>
import { getCoverNote } from "./services";
import { getBooking } from "@/modules/booking/services";
import { mapState, mapGetters } from "vuex";
import dayjs from '@/lib/dayjs';
export default {
  data() {
    return {
      errorLoadingData: false,
    };
  },
  methods: {
    showError(variant = null, _text) {
      this.$bvToast.toast(_text, {
        title: `Error Getting PDF`,
        variant: variant,
        solid: true,
      });
    },
    async getInsuranceCoverNotePDF(link) {
      // GET Printer Friendly
      // Check email
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });

      let result = await getBooking(
        this.getBookingSurname,
        this.getBookingNumber,
        this.userData.source,
        false,
        this.token
      ); // Method in Booking Store

      if (!result) {
        // Problem cannot continue
        // display alert
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true,
        });
        this.showError(
          "danger",
          "No match for email address. Log out and back in to update credentials."
        );
        return;
      }
      const x = Math.floor(Math.random() * 10000022350000 + 1);

      const covernoteData = {
        insurance_cover_note: this.getEssentialInfo.insurance_cover_note,
        filename: x,
      };
      covernoteData.insurance_cover_note.link = link;

      if (this.getItinerary.insuranceItem.insurancefor.includes("backpacker")) {
        covernoteData.insurance_cover_note.alreadytravelling === 'FALSE' ? false : true;
        covernoteData.insurance_cover_note.policy = "BACKPACKER";
      }
      result = await getCoverNote(covernoteData);
      const file = new Blob([result.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      a.setAttribute("download", covernoteData.filename);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });
    },
  },
  computed: {
    // Bring in the standard bookno & surname
    ...mapState("auth", ["userData", "token"]),
    ...mapGetters("booking", [
      "getSessionID",
      "getBookingInformation",
      "getBookingNumber",
      "getBookingSurname",
      "getEssentialInfo",
      "getItinerary",
    ]),

    // Used for the footer
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },
};
</script>
